import { createActions, createReducer } from 'reduxsauce'

import DetalhesEmpenhoService from '../../servicos/DetalhesEmpenhoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDetalhesEmpenhoInicio: [],
    buscaDetalhesEmpenhoSucesso: ['detalhesEmpenho'],
    buscaDetalhesEmpenhoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    resultado: [],
    selecionado: null,
    dataAtualizacaoDados: null,
}

// Ação para busca completa
Creators.buscaDetalhesEmpenho = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDetalhesEmpenhoInicio())
        let serv = new DetalhesEmpenhoService()
        return serv
            .consultarDetalhes(filtro)
            .then(response => dispatch(Creators.buscaDetalhesEmpenhoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDetalhesEmpenhoErro(error)))
    }
}

const buscaDetalhesEmpenhoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDetalhesEmpenhoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaDetalhesEmpenhoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, resultado: action.detalhesEmpenho, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DETALHES_EMPENHO_INICIO]: buscaDetalhesEmpenhoInicio,
    [Types.BUSCA_DETALHES_EMPENHO_ERRO]: buscaDetalhesEmpenhoErro,
    [Types.BUSCA_DETALHES_EMPENHO_SUCESSO]: buscaDetalhesEmpenhoSucesso,
})
